var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackagingOps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3807_1906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5157 4.20002C11.5157 3.20627 12.2728 2.40002 13.2061 2.40002H23.3487C24.282 2.40002 25.0391 3.20627 25.0391 4.20002V19.8C25.0391 20.7938 24.282 21.6 23.3487 21.6H15.9284C15.9918 21.4125 16.0235 21.21 16.0235 21V11.8988C16.6785 11.6513 17.1504 10.9838 17.1504 10.2V9.00002C17.1504 8.00627 16.3933 7.20002 15.46 7.20002H11.5157V4.20002ZM22.6197 15.4238C22.838 15.1913 22.838 14.8088 22.6197 14.5763L20.3658 12.1763C20.1474 11.9438 19.7882 11.9438 19.5699 12.1763L17.316 14.5763C17.0976 14.8088 17.0976 15.1913 17.316 15.4238C17.5343 15.6563 17.8935 15.6563 18.1119 15.4238L19.4043 14.0475V18.6C19.4043 18.93 19.6579 19.2 19.9678 19.2C20.2777 19.2 20.5313 18.93 20.5313 18.6V14.0475L21.8238 15.4238C22.0421 15.6563 22.4013 15.6563 22.6197 15.4238ZM2.5 9.00002C2.5 8.67002 2.75357 8.40002 3.06348 8.40002H15.46C15.7699 8.40002 16.0235 8.67002 16.0235 9.00002V10.2C16.0235 10.53 15.7699 10.8 15.46 10.8H3.06348C2.75357 10.8 2.5 10.53 2.5 10.2V9.00002ZM14.8965 12V20.4C14.8965 21.0638 14.3929 21.6 13.7696 21.6H4.75391C4.13057 21.6 3.62696 21.0638 3.62696 20.4V12H14.8965ZM7.5713 14.4C7.26139 14.4 7.00783 14.67 7.00783 15C7.00783 15.33 7.26139 15.6 7.5713 15.6H10.9522C11.2621 15.6 11.5157 15.33 11.5157 15C11.5157 14.67 11.2621 14.4 10.9522 14.4H7.5713Z",
    fill: "#656565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3807_1906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5391,
    height: 19.2,
    fill: "white",
    transform: "translate(2.5 2.40002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagingOps);
export default __webpack_public_path__ + "static/media/Packaging Ops.1a0e42e4cd9e9fbe76a504a67f81dd18.svg";
export { ForwardRef as ReactComponent };